module.exports = __webpack_public_path__ + "media/images/emoticons/art-418f3d9d7eefe99da8f55748ea5279ba.gif";